module.exports = __webpack_public_path__ + "media/Images/DotPink-beb8e9b1.svg";